import { v4 } from 'uuid';
import { CommentAsyncStatus, IComment } from '../models/comment.model';
import { ProjectID } from '../models/project.model';
import { hasDefinedProperties } from './object.helpers';
import { isObject } from 'lodash';

type CreateCommentPayload = {
  async_status: CommentAsyncStatus;
  project_id: ProjectID;
  owner: string;
  message: string;
  element_id?: string;
};

/** internal helper to create a comment object */
const createComment = (props: CreateCommentPayload): IComment => ({
  id: v4(),
  project_id: props.project_id,
  owner: props.owner,
  message: props.message,
  element_id: props.element_id,
  async_status: props.async_status,
  created_at: '',
  updated_at: '',
});

/**
 * creates a comment object with async status set to resolved. Use for user-generated comments.
 *
 * @returns IComment
 */
export const createUserComment = (
  props: Omit<CreateCommentPayload, 'async_status'>,
): IComment =>
  createComment({ ...props, async_status: CommentAsyncStatus.Resolved });

export const isComment = (data: unknown): data is IComment =>
  isObject(data) &&
  hasDefinedProperties(data as IComment, 'project_id', 'message', 'owner');
